<template>
	<div class="container-fluid">
		<bsf-layout>
			<bsf-col size='xs' col="12" id="rgroup">
				<div>
					<bsf-doc>
						<bsf-page-header>
							<h3 slot="header">
						Grid system 布局系统
					</h3>
						</bsf-page-header>
						<bsf-docmix>
							<h4 slot="header">
						一般布局
					</h4>
							<div slot="info">
								<p>使用目前比较流行的bootstrap3.x 框架的12等分布局系统 size为适配的端（lg sm xs 默认情况下为md） col为尺寸 12等分</p>
							</div>
							<div slot="example">
								<bsf-layout>
									<bsf-col size="xs" class="doc-col" v-for="n in 6" col="2">col-*-2</bsf-col>
									<bsf-col size="xs" class="doc-col" v-for="n in 4" col="3">col-*-3</bsf-col>
									<bsf-col size="xs" class="doc-col" v-for="n in 2" col="6">col-*-1</bsf-col>
									<bsf-col size="xs" class="doc-col" col="4">col-*-4</bsf-col>
									<bsf-col size="xs" class="doc-col" col="8">col-*-8</bsf-col>
								</bsf-layout>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">
						适配布局
					</h4>
							<div slot="info">
								<p>自动适配各平台 使用bootstrap的css</p>
							</div>
							<div slot="example">
								<bsf-layout>
									<bsf-col v-for="size in ['lg','md','sm','xs']" class="doc-col" :size="size" col="8">现在仅仅适配{{size}}到mobile</bsf-col>
								</bsf-layout>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">
						col-*-* offset
					</h4>
							<div slot="info">
								<p>col offset 设置</p>
							</div>
							<div slot="example">
								<bsf-layout>
									<bsf-col size="xs" class="doc-col" offset="1" col="2">offset</bsf-col>
								</bsf-layout>
								<bsf-layout>
									<bsf-col size="xs" class="doc-col" offset="2" col="2">offset</bsf-col>
								</bsf-layout>
								<bsf-layout>
									<bsf-col size="xs" class="doc-col" offset="3" col="2">offset</bsf-col>
								</bsf-layout>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">
						col-*-* push pull
					</h4>
							<div slot="info">
								<p>col push pull 设置</p>
							</div>
							<div slot="example">
								<bsf-layout>
									<bsf-col class="doc-col" size="xs" push="3" col="9">push3</bsf-col>
									<bsf-col class="doc-col" size="xs" pull="9" col="3">push9</bsf-col>
								</bsf-layout>
							</div>
						</bsf-docmix>
					</bsf-doc>
					<bsf-doc>
						<bsf-page-header>
							<h3 slot="header">
						表单元素 input
					</h3>
						</bsf-page-header>
						<bsf-docmix>
							<h4 slot="header">基础用法</h4>
							<div slot="example">
								<p>placeholder：</p>
								<bsf-input placeholder="请输入内容"></bsf-input>
								<p>初始值：</p>
								<bsf-input val="1234"></bsf-input>
								<p>密码输入框：</p>
								<bsf-input val="123456789" itype="text" :psd="true"></bsf-input>
								<p>textarea：</p>
								<bsf-input row="5" itype="textarea"></bsf-input>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">禁用状态</h4>
							<div slot="example">
								<bsf-input :disabled="true" val="默认的内容状态"></bsf-input>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">尺寸</h4>
							<p slot="info">size ['lg','sm']</p>
							<div slot="example">
								<bsf-input placeholder="请输入内容" val="input size 正常"></bsf-input>
								<bsf-input v-for="size in ['lg','sm']" placeholder="请输入内容" :size="size" val="input size lg sm"></bsf-input>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">带icon</h4>
							<div slot="example">
								<bsf-form-group icon="home">
									<bsf-input></bsf-input>
								</bsf-form-group>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">带icon和状态的input</h4>
							<p slot="info">['success', 'warning', 'error']</p>
							<div slot="example">
								<bsf-form-group v-for="s in ['success', 'warning', 'error']" icon="home" :states="s">
									<bsf-input></bsf-input>
								</bsf-form-group>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">有label的input</h4>
							<div slot="example">
								<bsf-form-group label="邮箱地址">
									<bsf-input placeholder="请输入你的邮箱地址"></bsf-input>
								</bsf-form-group>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">与label同行的input</h4>
							<p slot="info"> 需要bsf-form 设置inline</p>
							<div slot="example">
								<bsf-form direction="horizontal">
									<bsf-form-group label="邮箱地址：" csize="xs" col="10">
										<bsf-input placeholder="请输入你的邮箱地址"></bsf-input>
									</bsf-form-group>
									<bsf-form-group label="密码：" csize="xs" col="10">
										<bsf-input :psd="true" placeholder="请输入你的密码"></bsf-input>
									</bsf-form-group>
								</bsf-form>
								<bsf-form direction="inline">
									<bsf-form-group label="邮箱地址：">
										<bsf-input placeholder="请输入你的邮箱地址"></bsf-input>
									</bsf-form-group>
									<bsf-form-group label="密码">
										<bsf-input :psd="true" placeholder="请输入你的用密码"></bsf-input>
									</bsf-form-group>
								</bsf-form>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">form帮助提示信息</h4>
							<p slot="info">设置帮助信息</p>
							<div slot="example">
								<bsf-form direction="horizontal">
									<bsf-form-group label="邮箱地址：" csize="xs" col="10" help="建议使用国内邮箱">
										<bsf-input placeholder="请输入你的邮箱地址"></bsf-input>
										<bsf-input></bsf-input>
									</bsf-form-group>
									<bsf-form-group label="密码：" csize="xs" col="10" help="请勿向第三方泄露您的密码信息">
										<bsf-input :psd="true" placeholder="请输入你的密码"></bsf-input>
									</bsf-form-group>
								</bsf-form>
							</div>
						</bsf-docmix>
					</bsf-doc>
					<bsf-doc>
						<bsf-page-header>
							<h3 slot="header">表单元素Checkboxes and radios</h3>
						</bsf-page-header>
						<bsf-docmix>
							<h4 slot="header">一般用法</h4>
							<div slot="example">
								<bsf-checkbox label="使用bsf-vue扩展" name="ck1"></bsf-checkbox>
								<bsf-checkbox label="使用bsf-vue扩展" name="ck1"></bsf-checkbox>
								<bsf-checkbox :disabled="true" label="使用bsf-css扩展" name="ck1"></bsf-checkbox>
								<hr />
								<bsf-radio label="使用bsf-vue扩展" name="op1"></bsf-radio>
								<bsf-radio label="" name="op1"></bsf-radio>
								<bsf-radio :disabled="true" label="我不使用bsf-vue扩展" name="op1"></bsf-radio>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">inline</h4>
							<div slot="example">
								<bsf-checkbox inline label="check1" name="ck2"></bsf-checkbox>
								<bsf-checkbox inline label="check2" name="ck2"></bsf-checkbox>
								<bsf-checkbox inline label="check3" name="ck2"></bsf-checkbox>
								<hr />
								<bsf-radio inline label="radio1" name="op2"></bsf-radio>
								<bsf-radio inline label="radio2" name="op2"></bsf-radio>
								<bsf-radio inline label="radio3" name="op2"></bsf-radio>
							</div>
						</bsf-docmix>
					</bsf-doc>
					<bsf-doc>
						<bsf-page-header>
							<h3 slot="header">表单元素select</h3>
						</bsf-page-header>
						<bsf-docmix>
							<p slot="info">:data 数据源;sname 展示内容,sval select value</p>
							<div slot="example">
								<bsf-select :data="selectDate" sname="name" sval="value" @selected="selected"></bsf-select>
								<bsf-select :data="selectDate" sname="name" sval="value" @selected="selected"></bsf-select>
								<!--					<bsf-select :multiple="true" :data="selectDate" sname="name" sval="value"  @selected="selected"></bsf-select>-->
								<bsf-input-group addon="您选择了：">
									<bsf-input slot="input" placeholder="请输入金额" :val="selmsg"></bsf-input>
								</bsf-input-group>
							</div>
						</bsf-docmix>
					</bsf-doc>
					<bsf-doc>
						<bsf-page-header>
							<h3 slot="header">Button 按钮</h3>
						</bsf-page-header>
						<bsf-docmix>
							<h4 slot="header">一般按钮</h4>
							<div slot="info">
								<p>基础的按钮用法。</p>
							</div>
							<div slot="example">
								<ul class="list-inline">
									<li v-for="btn in ['default', 'primary', 'success', 'info', 'warning', 'danger', 'ces']">
										<bsf-btn :btype="btn">{{btn}}</bsf>
									</li>
									<li>
										<bsf-btn btype="link">link</bsf-btn>
									</li>
								</ul>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">unbg按钮</h4>
							<div slot="info">
								<p>无背景按钮。</p>
							</div>
							<div slot="example">
								<ul class="list-inline">
									<li v-for="btn in ['default', 'primary', 'success', 'info', 'warning', 'danger', 'ces']">
										<bsf-btn :unbg="true" :btype="btn">{{btn}}</bsf-btn>
									</li>
								</ul>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">边框按钮</h4>
							<div slot="info">
								<p>边框按钮。</p>
							</div>
							<div slot="example">
								<ul class="list-inline">
									<li v-for="btn in ['default', 'primary', 'success', 'info', 'warning', 'danger', 'ces']">
										<bsf-btn :border="true" :btype="btn">{{btn}}</bsf-btn>
									</li>
								</ul>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">按钮尺寸</h4>
							<div slot="info">
								<p>不同尺寸的按钮。</p>
							</div>
							<div slot="example">
								<ul class="list-inline">
									<li v-for="size in ['lg','sm','xs']">
										<bsf-btn btype="ces" :size="size">{{size}}尺寸按钮</bsf-btn>
									</li>
									<li>
										<bsf-btn>默认尺寸</bsf-btn>
									</li>
								</ul>
								<bsf-btn btype='ces' :block="true">block 按钮</bsf-btn>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">有icon的按钮</h4>
							<div slot="info">
								<p>可以给按钮增加icon。</p>
							</div>
							<div slot="example">
								<bsf-btn btype='ces' icon="icon-home"></bsf-btn>
								<bsf-btn btype='ces' icon="icon-home">按钮</bsf-btn>
								<bsf-btn btype='ces' :icon="['icon-home','right']">按钮</bsf-btn>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">按钮状态控制</h4>
							<div slot="info">
								<p>按钮禁用不能点击。</p>
							</div>
							<div slot="example">
								<bsf-btn btype="ces" :disabled="true" :border="true">按钮</bsf-btn>
								<bsf-btn btype="ces" :disabled="true" :unbg="true">按钮</bsf-btn>
								<bsf-btn btype="ces" :disabled="true">按钮</bsf-btn>
							</div>
						</bsf-docmix>
					</bsf-doc>
					<bsf-doc>
						<bsf-page-header>
							<h3 slot="header">inputgroup</h3>
						</bsf-page-header>
						<bsf-docmix>
							<h4 slot="header">一般用法和样式</h4>
							<div slot="example">
								<bsf-input-group :addon="['$','.00']">
									<bsf-input slot="input" placeholder="请输入金额"></bsf-input>
								</bsf-input-group>
								<bsf-input-group addon="$">
									<bsf-input slot="input" placeholder="请输入金额"></bsf-input>
								</bsf-input-group>
								<bsf-input-group addon=".00" :right="true">
									<bsf-input slot="input" placeholder="请输入金额"></bsf-input>
								</bsf-input-group>
								<bsf-input-group addon="https://example.com/users/">
									<bsf-input slot="input"></bsf-input>
								</bsf-input-group>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">inputgroup 尺寸</h4>
							<div slot="example">
								<bsf-input-group addon="$" :size="size" v-for="size in ['lg','sm']">
									<bsf-input slot="input" :val="[size]+'尺寸'" placeholder="用户名称"></bsf-input>
								</bsf-input-group>
								<bsf-input-group addon="$">
									<bsf-input slot="input" val="一般尺寸" placeholder="用户名称"></bsf-input>
								</bsf-input-group>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">Table</h4>
							<div slot="info">
								<ol>
									<li>label 表头名称</li>
									<li>prop td 字段名</li>
									<li>data 数据</li>
									<li>[bordered,striped,hover,condensed] bs样式</li>
								</ol>
							</div>
							<div slot="example">
								<p>默认样式</p>
								<bsf-table :data="tableData">
									<e-column label="名字" prop="name"></e-column>
									<e-column label="日期" prop="date"></e-column>
									<e-column label="地址" prop="address"></e-column>
								</bsf-table>
								<hr />
								<p>border</p>
								<bsf-table bordered :data="tableData">
									<e-column label="名字" prop="name"></e-column>
									<e-column label="日期" prop="date"></e-column>
									<e-column label="地址" prop="address"></e-column>
								</bsf-table>
								<hr />
								<p>striped</p>
								<bsf-table striped :data="tableData">
									<e-column label="名字" prop="name"></e-column>
									<e-column label="日期" prop="date"></e-column>
									<e-column label="地址" prop="address"></e-column>
								</bsf-table>
								<hr />
								<p>hover</p>
								<bsf-table hover :data="tableData">
									<e-column label="名字" prop="name"></e-column>
									<e-column label="日期" prop="date"></e-column>
									<e-column label="地址" prop="address"></e-column>
								</bsf-table>
								<hr />
								<p>condensed</p>
								<bsf-table condensed :data="tableData">
									<e-column label="名字" prop="name"></e-column>
									<e-column label="日期" prop="date"></e-column>
									<e-column label="地址" prop="address"></e-column>
								</bsf-table>
							</div>
						</bsf-docmix>
					</bsf-doc>
					<bsf-doc>
						<bsf-page-header>
							<h3 slot="header">components 组件</h3>
						</bsf-page-header>
						<bsf-docmix>
							<h4 slot="header">Dropdowns & Button dropdowns</h4>
							<div slot="info">
								<ul class="list-unstyled">
									<li>1.data 数据源</li>
									<li>2.dptype dropdown方向</li>
									<li>3.dname dropdown的文字</li>
									<li>4.dval dropdown的数据</li>
								</ul>
							</div>
							<div slot="example">
								<bsf-dropdown :data="dropdata" :up="true" :inline="true" dname="name" dval="value" @selected="dpselect"></bsf-dropdown>
								<bsf-dropdown :data="dropdata" :inline="true" dname="name" dval="value" @selected="dpselect"></bsf-dropdown>
								<bsf-dropdown :data="dropdata" dname="name" dval="value" :btype="type" v-for="type in ['primary', 'success', 'info', 'warning', 'danger', 'ces']" @selected="dpselect"></bsf-dropdown>
								<hr />
								<bsf-dropdown :data="dropdata" dname="name" :inline="true" dval="value" @selected="dpselect"></bsf-dropdown>
								<bsf-dropdown :data="dropdata" dname="name" :up="true" :split="true" btype="danger" dval="value" @selected="dpselect"></bsf-dropdown>
								<bsf-dropdown :data="dropdata" dname="name" :split="true" btype="success" dval="value" @selected="dpselect"></bsf-dropdown>
								<hr />
								<p>尺寸 ['lg','sm','xs']</p>
								<bsf-dropdown :data="dropdata" :bsize="size" btype="info" v-for="size in ['lg','sm','xs']" dname="name" dval="value" @selected="dpselect"></bsf-dropdown>
								<bsf-input-group addon="您选择了">
									<bsf-input slot="input" placeholder="请输入金额" :val="dpval"></bsf-input>
								</bsf-input-group>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">Button groups</h4>
							<div slot="info">
								<p>autofocus="true" 默认focus</p>
							</div>
							<div slot="example">
								<bsf-btn-group>
									<bsf-btn btype="ces" autofocus="true">按钮</bsf-btn>
									<bsf-btn btype="ces">按钮</bsf-btn>
									<bsf-btn btype="ces">按钮</bsf-btn>
								</bsf-btn-group>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">Navs</h4>
							<div slot="info">
								<p>[tabs,pills]</p>
							</div>
							<div slot="example">
								<bsf-nav :data="navdata" btype="tabs"></bsf-nav>
								<bsf-nav :data="navdata" btype="pills"></bsf-nav>
								<bsf-nav :data="navdata" :jfd="true" btype="tabs"></bsf-nav>
								<bsf-nav :data="navdata" btype="pills" :jfd="true"></bsf-nav>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">Navbar</h4>
							<div slot="info">
								<p>navbar</p>
							</div>
							<div slot="example">
								<p>普通的navbar 普通的用</p>
								<bsf-navbar></bsf-navbar>
								<p>inverse效果</p>
								<bsf-navbar inverse></bsf-navbar>
								<p>logo</p>
								<bsf-navbar name="logo"></bsf-navbar>
								<p>Brand image</p>
								<bsf-navbar name="logo" :logo="bslogo"></bsf-navbar>
								<p>form</p>
								<bsf-navbar :logo="bslogo">
									<bsf-form class="navbar-form navbar-left" slot="form">
										<bsf-form-group>
											<bsf-input></bsf-input>
										</bsf-form-group>
										<bsf-btn type="submit">提交</bsf-btn>
									</bsf-form>
								</bsf-navbar>
								<p>Button，text，link</p>
								<bsf-navbar :logo="bslogo">
									<p class="navbar-right">
										<bsf-btn class="navbar-btn">登录</bsf-btn>
										<bsf-btn class="navbar-btn" btype="ces">注册</bsf-btn>
									</p>
									<p class="navbar-text">Signed in as
										<a href="#" class="navbar-link">Mark Otto</a>
									</p>
								</bsf-navbar>
								<bsf-navbar :logo="bslogo">
									<bsf-nav :data="navdata" class="navbar-nav"></bsf-nav>
								</bsf-navbar>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">Breadcrumbs</h4>
							<div slot="info"></div>
							<div slot="example">
								<bsf-breadcrumb :data="navdata1" :arrow="true"></bsf-breadcrumb>
								<bsf-breadcrumb :data="navdata1"></bsf-breadcrumb>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">Pagination</h4>
							<p slot="info"> ['lg','sm']</p>
							<div slot="example">
								<bsf-pagination :total="100"></bsf-pagination>
								<bsf-pagination :total="100" :psize="[size]" v-for="size in ['lg','sm']"></bsf-pagination>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">label</h4>
							<p slot="info">type in ['default', 'primary', 'success', 'info', 'warning', 'danger'],close [true,false]</p>
							<div slot="example">
								<bsf-label :type="type" v-for="type in ['default', 'primary', 'success', 'info', 'warning', 'danger']">标签</bsf-label>
								<hr />
								<bsf-label :type="tag.type" :close="true" v-for="(tag,index) in tags" @close="closeLabel(tag)">{{tag.name}}</bsf-label>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">Badges</h4>
							<div slot="example">
								<bsf-btn>服务信息
									<bsf-badges val="15"></bsf-badges>
								</bsf-btn>
								<bsf-btn>服务信息
									<bsf-badges :max="10" :val="11" up imp></bsf-badges>
								</bsf-btn>
								<bsf-btn>服务信息
									<bsf-badges val="new" up></bsf-badges>
								</bsf-btn>
								<bsf-btn>服务信息
									<bsf-badges val="new" up imp></bsf-badges>
								</bsf-btn>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">Alert</h4>
							<div slot="example">
								<bsf-alert content="你的服务器需要在近期续费"></bsf-alert>
								<bsf-alert :type="alert.type" v-for="alert in alertData" :position="alert.position" :content="alert.content" @close="closeAlert(alert)" close></bsf-alert>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">Progress</h4>
							<div slot="example">
								<bsf-progress :state="70"></bsf-progress>
								<bsf-progress :state="80" :end="true"></bsf-progress>
								<hr />
								<bsf-progress :type="type" v-for="type in ['success','info','warning','danger']" :state="40" :end="true"></bsf-progress>
								<hr />
								<bsf-progress :state="70" :end="true" :striped="true"></bsf-progress>
								<bsf-progress :state="70" :end="true" type="success" striped animate></bsf-progress>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">Modal</h4>
							<p slot="info">modal尺寸size:[lg,sm,full]</p>
							<div slot="example">
								<bsf-btn @click="modalshow2=true">显示Modal</bsf-btn>
								<bsf-modal :show="modalshow2" @close="modalshow2=false" header="modal标题">
								</bsf-modal>
								<bsf-btn @click="modalshow3=true">显示Modalsm</bsf-btn>
								<bsf-modal :show="modalshow3" @close="modalshow3=false" size="sm">
								</bsf-modal>
								<bsf-btn @click="modalshow=true">显示Modal lg</bsf-btn>
								<bsf-modal :show="modalshow" @close="modalshow=false" size="lg">
								</bsf-modal>
								<bsf-btn @click="modalshow1=true">显示Modal full</bsf-btn>
								<bsf-modal :show="modalshow1" @close="modalshow1=false" size="full">
								</bsf-modal>
							</div>
						</bsf-docmix>
						<bsf-docmix>
							<h4 slot="header">sideMenu</h4>
							<p slot="info">左侧边导航</p>
							<div slot="example">
								<bsf-layout>
									<bsf-col size="xs" col="3" id="lgroup">
										<bsf-smenu>
											<bsf-smenuli icon="home" label="导航名称">
												<bsf-smenu slot="menu">
													<bsf-smenuli label="二级导航"></bsf-smenuli>
												</bsf-smenu>
											</bsf-smenuli>
											<bsf-smenuli icon="user" label="导航名称"></bsf-smenuli>
											<bsf-smenuli icon="home" label="导航名称">
												<bsf-label type="warning" slot="label">16/24</bsf-label>
											</bsf-smenuli>
											<bsf-smenuli icon="sms" label="导航名称">
												<bsf-badges slot="label" :max="10" :val="11" imp></bsf-badges>
											</bsf-smenuli>
											<bsf-smenuli icon="shezhi" label="导航名称">
												<bsf-smenu slot="menu">
													<bsf-smenuli label="二级导航"></bsf-smenuli>
													<bsf-smenuli label="二级导航"></bsf-smenuli>
													<bsf-smenuli label="二级导航"></bsf-smenuli>
													<bsf-smenuli label="二级导航"></bsf-smenuli>
												</bsf-smenu>
											</bsf-smenuli>
										</bsf-smenu>
									</bsf-col>
								</bsf-layout>
							</div>
						</bsf-docmix>
					</bsf-doc>
			</bsf-col>
			</div>
		</bsf-layout>
	</div>
</template>

<script>
	import bslogo from "../assets/bs.png"
	import bsfLayout from './css/layout'
	import bsfCol from './css/col'
	//
	import bsfDoc from './doc/doc'
	import bsfDocmix from './doc/docmix'
	//
	import bsfBtn from './css/form/btn'
	import bsfBtnGroup from './comp/btngroup'
	import bsfForm from './css/form/form'
	import bsfInput from './css/form/input'
	import bsfCheckbox from "./css/form/checkbox"
	import bsfRadio from "./css/form/radio"
	import bsfSelect from "./css/form/select"
	import bsfFormGroup from './css/form/formgroup'
	import bsfInputGroup from './css/form/inputgroup'
	import bsfTable from './css/table'
	//
	import bsfSmenu from './comp/smenu'
	import bsfSmenuli from './comp/slot/smenuli'
	import bsfPageHeader from './comp/pageheader'
	import bsfDropdown from './comp/dropdown'
	import bsfNav from './comp/nav'
	import bsfNavbar from './comp/navbar'
	import bsfBreadcrumb from './comp/breadcrumbs'
	import bsfPagination from './comp/pagination'
	import bsfLabel from './comp/label'
	import bsfBadges from './comp/badges'
	import bsfAlert from './comp/alert'
	import bsfProgress from './comp/progress'
	import bsfModal from './comp/modal'

	export default {
		name: 'warp',
		components: {
			bsfDoc,
			bsfDocmix,
			//
			bsfLayout,
			bsfCol,
			//
			bsfPageHeader,
			bsfBtn,
			bsfBtnGroup,
			bsfForm,
			bsfInput,
			bsfCheckbox,
			bsfRadio,
			bsfSelect,
			bsfFormGroup,
			bsfInputGroup,
			bsfTable,
			//
			bsfSmenu,
			bsfSmenuli,
			bsfDropdown,
			bsfNav,
			bsfNavbar,
			bsfBreadcrumb,
			bsfPagination,
			bsfLabel,
			bsfBadges,
			bsfAlert,
			bsfProgress,
			bsfModal
		},
		data() {
			return {
				bslogo: bslogo,
				selmsg: "",
				dpval: "",
				modalshow: false,
				modalshow1: false,
				modalshow2: false,
				modalshow3: false,
				selectDate: [{
					name: "selectName",
					value: "a"
				}, {
					name: "selectName1",
					value: "b"
				}, {
					name: "selectName2",
					value: "c"
				}, {
					name: "selectName3",
					value: "d"
				}],
				dropdata: [{
					name: "dropdownName",
					value: "dropdownValue"
				}, {
					name: "dropdownName1",
					value: "dropdownValue1"
				}, {
					name: "dropdownName2",
					value: "dropdownValue2"
				}, {
					name: "dropdownName3",
					value: "dropdownValue3"
				}],
				navdata: [{
					name: "Home",
				}, {
					name: "Profile",
				}, {
					name: "Message",
				}],
				navdata1: [{
					name: "Home",
					href: ""
				}, {
					name: "Profile",
					href: ""
				}, {
					name: "Message",
					href: "",
					active: true
				}],
				tags: [{
					key: 1,
					name: '标签一',
					type: ''
				}, {
					key: 2,
					name: '标签二',
					type: ''
				}, {
					key: 5,
					name: '标签三',
					type: 'primary'
				}, {
					key: 3,
					name: '标签四',
					type: 'success'
				}, {
					key: 4,
					name: '标签五',
					type: 'warning'
				}, {
					key: 6,
					name: '标签六',
					type: 'danger'
				}],
				tableData: [{
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1517 弄'
				}, {
					date: '2016-05-01',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1519 弄'
				}, {
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄'
				}],
				alertData: [{
					aid: "2017010601",
					content: "你的www.bsfans.com域名需要续费",
					type: "success",
				}, {
					aid: "2017010601",
					content: "你的www.bsfans.com域名需要续费",
					type: "info"
				}, {
					aid: "2017010601",
					content: "你的www.bsfans.com域名需要续费"
				}, {
					aid: "2017010601",
					content: "你的www.bsfans.com域名需要续费",
					type: "danger"
				}, {
					aid: "2017010601",
					content: "你的www.bsfans.com域名需要续费",
					type: "danger"
				}, {
					aid: "2017010601",
					content: "你的www.bsfans.com域名需要续费",
					position: "top"
				}]
			}
		},
		methods: {
			selected(v) {
				this.selmsg = '您选择了 : ' + v
			},
			dpselect(v) {
				this.dpval = v
			},
			closeLabel(tag) {
				this.tags.splice(this.tags.indexOf(tag), 1);
			},
			closeAlert(aid) {
				this.alertData.splice(this.alertData.indexOf(aid), 1);
			}
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../assets/lib/css.less";
	body {
		font-family: @ffmix;
		background-color: @nbgc;
	}
	
	#lgroup {
		.pd(0);
		/*		.pdt(4*@mpb);*/
	}
	
	#rgroup {
		background-color: @cwh;
		.pd(2*@mpb);
		>div {
			.ohd;
		}
	}
	
	.doc {
		margin: 0 -15px;
		padding: 0 15px;
	}
	
	.doc-col {
		height: 50px;
		line-height: 50px;
		background-color: @cc2 ;
		.bdr;
		.mgb;
		.tac;
		color: @cwh;
	}
	
	.docmix {
		input+input {
			.mgt;
		}
		.input-group+.input-group {
			.mgt;
		}
		select+input {
			.mgt;
		}
		select+select {
			.mgt;
			&+input {
				.mgt;
			}
		}
		.dropdown+.dropdown:not(.btn-group),
		.dropup+.dropup,
		.dropup+.dropdown:not(.btn-group),
		.dropdown+.dropup {
			.mgt;
		}
		.dropdown,
		.dropup {
			&+input,
			&+.input-group {
				.mgt;
			}
		}
		.btn-group+.btn-group {
			.mgt(0);
		}
		.nav+.nav {
			.mgt
		}
		.label+.label {
			.mgl;
		}
	}
	
	.form-inline {
		.form-group+.form-group {
			.mgl;
		}
	}
</style>


// WEBPACK FOOTER //
// warp.vue?d4b76c0a